
export const FETCH_ACCOUNT_PROPERTYS_REQUEST = 'FETCH_ACCOUNT_PROPERTYS_REQUEST';
export const FETCH_ACCOUNT_PROPERTYS_SUCCESS = 'FETCH_ACCOUNT_PROPERTYS_SUCCESS';
export const FETCH_ACCOUNT_PROPERTYS_FAILURE = 'FETCH_ACCOUNT_PROPERTYS_FAILURE';

export const FETCH_SINGLE_ACCOUNT_PROPERTYS_REQUEST = 'FETCH_SINGLE_ACCOUNT_PROPERTYS_REQUEST';
export const FETCH_SINGLE_ACCOUNT_PROPERTYS_SUCCESS = 'FETCH_SINGLE_ACCOUNT_PROPERTYS_SUCCESS';
export const FETCH_SINGLE_ACCOUNT_PROPERTYS_FAILURE = 'FETCH_SINGLE_ACCOUNT_PROPERTYS_FAILURE';

export const CREATE_ACCOUNT_PROPERTYS_REQUEST = 'CREATE_ACCOUNT_PROPERTYS_REQUEST';
export const CREATE_ACCOUNT_PROPERTYS_SUCCESS = 'CREATE_ACCOUNT_PROPERTYS_SUCCESS';
export const CREATE_ACCOUNT_PROPERTYS_FAILURE = 'CREATE_ACCOUNT_PROPERTYS_FAILURE';

export const CREATE_ACCOUNT_PROPERTY_FORM = 'CREATE_ACCOUNT_PROPERTY_FORM';

export const ACCOUNT_PROPERTY_FORM_RESET = 'ACCOUNT_PROPERTY_FORM_RESET';